<script setup lang="ts">
import Prediction from './Prediction.vue'

const props = defineProps({
  predictions: {
    type: Array,
    default: null,
  },
  open: { bool: Boolean },
  highlightedPrediction: {
    type: Number,
    default: -1,
  },
})

const emit = defineEmits([ 'select' ])
</script>

<template>
  <div
      class="predictions"
      :class="{ 'predictions--open' : props.open }"
  >
    <template v-if="predictions.length">
      <Prediction
          v-for="(prediction, index) in props.predictions"
          :key="prediction.place_id"
          :tabindex="0"
          :highlighted="index === props.highlightedPrediction"
          v-bind="prediction"
          @click="emit('select', prediction)"
      />
    </template>
    <slot/>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/css/mixins/styling.scss";

.predictions {
  @include shadow-md;
  display:          none;
  opacity:          0;

  position:         absolute;
  flex-direction:   column;
  top:              0;
  left:             0;
  width:            calc(100% + 1rem);
  background-color: #ffffff;
  padding:          5rem 0 0 0;
  transform:        translate(-0.5rem, -0.4rem);
  z-index:          40;
  border-radius:    2.5rem;
  border:           1px solid var(--color-neutral-quaternary);
  transition:       all 0.2s;

  &--open {
    opacity: 1;
    display: flex;
  }
}
</style>
